// SPDX-License-Identifier: GPL-3.0-only
// Copyright (C) 2026 Kyle Johnson
// This file is part of Hushold.
//
// Hushold is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as
// published by the Free Software Foundation, version 3.

import { Buffer } from 'buffer';
if (typeof globalThis.Buffer === 'undefined') {
  (globalThis as unknown as Record<string, unknown>)['Buffer'] = Buffer;
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.js';
import './i18n/config.js';
import './index.css';
import { BUILD_STAMP } from './lib/appVersion.js';

// One-line build stamp for bug reports and curious devtools users.
console.info(`Hushold ${BUILD_STAMP} — https://github.com/kylepjohnson/hushold`);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
